<youtube-player [videoId]="videoId"
                width="830" height="468"
                [playerVars]="{
                start: start,
                showinfo: 0, controls: 1, color: 'white', iv_load_policy: 0, rel: 0, autoplay: 1, modestbranding: 1}"></youtube-player>
